import React, { useState, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { CardIdContext } from 'src/components/pages/sales/reservation/context/CardIdContext'

export const WrapperCardId = ({ children }) => {
  const [cardId, setCardId] = useState(null)

  useEffect(() => {
    const cardIdGenerate = uuidv4()
    setCardId(cardIdGenerate)
  }, [])
  return <CardIdContext.Provider value={{ cardId }}>{children}</CardIdContext.Provider>
}
